import Swal from "sweetalert2";

// Sem pausa no hover: se o mouse ficar parado sobre o toast (posição bottom
// cobre a área onde o usuário está clicando), o timer nunca seria retomado e
// o toast ficaria aberto pra sempre. Todo toast da aplicação deve fechar
// sozinho em 5s, sem exceção.
export const Toast = Swal.mixin({
  toast: true,
  position: "bottom",
  width: "50%",
  animation: false,
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
});
